import { render } from "./ClientNameComponent.vue?vue&type=template&id=5ae7e04a&scoped=true"
import script from "./ClientNameComponent.vue?vue&type=script&lang=js"
export * from "./ClientNameComponent.vue?vue&type=script&lang=js"

import "./ClientNameComponent.vue?vue&type=style&index=0&id=5ae7e04a&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ae7e04a"]])

export default __exports__